import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=4af96ae0&scoped=true&lang=pug&"
import script from "./Teaser.vue?vue&type=script&lang=js&"
export * from "./Teaser.vue?vue&type=script&lang=js&"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=4af96ae0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af96ae0",
  null
  
)

export default component.exports